import React, { useEffect, useRef } from "react";
import { Img } from "react-image";
import AssetsManager from "../../classes/AssetsManager";
import AssetUtility from "../../classes/AssetUtility";
import Utils from "../../classes/Utilities";
import DomUtils from "../../classes/utilities/DomUtils";
import { DocumentIconCode, DocumentIconPDF, DocumentIconSpreadsheet, DocumentIconText, DocumentIconVideo, Spinner } from "../Iconset";
import Grid from "../layout/Grid";
import Panel from "../layout/Panel";
import Spacer from "../layout/Spacer";
import { useTypedDispatch, useTypedSelector } from "../../state/hooks";
import useForceUpdate from "../reactUtils/useForceUpdate";
import { StoreActions } from "../../state/store";

export default function UISidebarAttachments(props)
{
	const forceUpdate = useForceUpdate();
	const dispatch = useTypedDispatch();

	const attachments = useTypedSelector(state => state.attachmentsModule.attachments[props.stepId]);
	
	const rootRef = useRef<HTMLDivElement>(null);

	useEffect(() => 
	{
		forceUpdate();
	}, [rootRef.current]);

	function renderAttachments()
	{
		function getAttachmentPreview(extension, previewUrl)
		{
			switch(extension)
			{
				case "png":
				case "jpg":
				case "jpeg":
					return <Img className={"attachmentImagePreview"}
						src={previewUrl}
						loader={
							<Spinner
								data-name={"asset-preview-item-thumbnail-spinner"}
								size={50}
							/>
						}
						onClick={() => dispatch(StoreActions.ui.setFullscreenAssetUrl(previewUrl))}
					/>;
				case "mp4":
					return <DocumentIconVideo className={"attachmentImagePreview"} />;
				case "xls":
				case "xlsx":
					return <DocumentIconSpreadsheet className={"attachmentImagePreview"} />;
				case "pdf":
					return <DocumentIconPDF className={"attachmentImagePreview"} />;
				case "html":
				case "vrml":
					return <DocumentIconCode className={"attachmentImagePreview"} />;
				case "doc":
				case "docx":
				default:
					return <DocumentIconText className={"attachmentImagePreview"} />;
			}
		}

		const output = new Array<JSX.Element>();

		if(!rootRef.current) return;
		const rootRect = DomUtils.getDomElementRect(rootRef.current);		
		const columnCount = 3;
		const elementSize = (rootRect?.width ?? 50) / columnCount - 6; // accomodate for some padding

		for(let i = 0; i < attachments?.length; i++)
		{
			const assetProps = AssetsManager.getPropsForAsset(attachments[i]);
			if(!assetProps) continue;

			output.push(
				<div className={"sidebarAttachmentItemRoot"}
					key={i}
					style={{
						width: elementSize + "px",
						height: elementSize + "px",
					}}
				>
					{i + 1}
					<Spacer size={{ x: "2px" }} />
					<Panel>
						{getAttachmentPreview(Utils.getFileExtension(assetProps.label), AssetUtility.getPreviewAssetURL(attachments[i]))}
						<Spacer size={{ y: "4px" }} />
						<div className={"attachmentItemLabel"}>
							{assetProps.label}
						</div>
					</Panel>
				</div>
			);
		}

		return output;
	}

	return (
		<Panel ref={rootRef}
			className={'uiSidebarPreviewContainer'}
			style={{ opacity:'0.8' }}
		>
			<Grid>
				{renderAttachments()}
			</Grid>
		</Panel>
	);
}